/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager {

    import IPromo = Meevo.Model.IPromotionalContent;
    import IWalkInSettings = Meevo.Model.IWalkInSettings;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export interface IWalkInSettingsService {
        fetchSettings: () => ng.IPromise<any>,
        settings: IWalkInSettings,
        logoUrl: string,
        promo: Array<IPromo>,
        kioskConfirmationTimeout: number,
        kioskClientEmail: boolean,
        displayShowTotal: boolean,
        kioskServiceId: Guid | string,
        promotionImages: string[],
        backgroundUrl: string

    }

    export class WalkInSettingsService implements IWalkInSettingsService{
        _settings: IWalkInSettings;
        promotionImages: string[] = [];

        constructor (
            protected $q: ng.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService
        ) {
            this.settings = {
                promotionalContents: [],
                logoUrl: '',
                backgroundUrl: '',
                walkInConfirmationWindowWaitTimeInSec: 15,
                enableClientEmailLookupForWalkIn: false,
                appointmentNotesEnabled: false,
                walkInDisplayMonitorShowTotalTime: false,
                walkInMostPopularServiceId: '',
                waitListHeaderColor: '#000000',
                waitListHeaderFontColor: '#FFFFFF',
                waitListMainFontColor: '#591C28',
                termsAndConditions: {
                    objectStateEnum: 0,
                    termsAndConditionsTypeEnum: Meevo.Model.TermsAndConditionsTypeEnum.WalkInTermsAndConditions,
                    entityVersion: 1
                },
                notificationPositionX: 2,
                notificationClosingMins: 15,
                customerNameFormat: Meevo.Model.CustomerNameDisplayFormatEnum.FirstNameCommaLast4ofPhoneNumber,
                walkinEnableCustomerOnlineSignupFor: false,
                hideAnyGenderOptions: false,
                customConfirmationPageMessage: '',
                appointmentBookFullMessage: '',
                maximumNumberOfWalkinGuests: 0,
                settings: []
            };
        }

        public fetchSettings (): ng.IPromise<any> {
            let deferred = this.$q.defer();

            if (this.settings.logoUrl === '') {
                this.dataService.customMethodData(
                    `${this.appSettings.API_ROOT}/WalkInSettings`,
                    'GET',
                    {}
                )
                    .then(({data}) => {
                      this.settings = data;
                        this.setPromotionImages();
                        this.getPromoText();
                        this.setLogoUrl();
                        this.setBackgroundUrl();

                        deferred.resolve(data);
                    })
                    .catch(() => {
                        deferred.reject();
                    });
            } else {
                deferred.resolve(this.settings);
            }

            return deferred.promise;
        }

        get settings () {
            return this._settings;
        }

        set settings(newValue) {
            this._settings = newValue;
        }

        static get promotionalContentKeys() {
            return ['promotionalContent1', 'promotionalContent2', 'promotionalContent3', 'promotionalContent4'];
        }

        setPromotionImages() {
            this.promotionImages = WalkInSettingsService.promotionalContentKeys.reduce((images, key) => {
                let setting = this.settings[key] as Meevo.Model.IStorageFile;

                if (angular.isDefined(setting.meevoFile))
                    images.push(this.searchFile(setting, ""));

                return images;
            }, []);
        }

        get hasPromoImages(): boolean {
            return this.promotionImages.length > 0;
        }

        setLogoUrl() {
            this.settings.logoUrl = this.searchFile(this.settings.businessLogo, "");
        }

        setBackgroundUrl() {
            this.settings.backgroundUrl = this.searchFile(this.settings.backgroundImage,"");
        }

        get logoUrl (): string {
            return this.settings.logoUrl;
        }

        get backgroundUrl(): string {
            return this.settings.backgroundUrl;
        }

        get promo (): Array<IPromo> {
            return this.settings.promotionalContents;
        }

        get kioskConfirmationTimeout (): number {
            return this.settings.walkInConfirmationWindowWaitTimeInSec;
        }

        get kioskClientEmail (): boolean {
            return this.settings.enableClientEmailLookupForWalkIn;
        }

        get kioskServiceId (): Guid|string {
            return this.settings.walkInMostPopularServiceId;
        }

        get displayShowTotal (): boolean {
            return this.settings.walkInDisplayMonitorShowTotalTime;
        }

        get businessName(): string {
          return this.settings.businessName;
        }

        get colors (): any {
            return {
                headerColor: this.settings.waitListHeaderColor,
                headerFontColor: this.settings.waitListHeaderFontColor,
                mainFontColor: this.settings.waitListMainFontColor,
            };
        }

        getPromoText(): void {
          for (let i = 0; i < 3; i++) {
            this.settings[`promotion${i+1}Title`] = this.settings.promotionalContents[i].displayName;
            this.settings[`promotion${i+1}Description`] = this.settings.promotionalContents[i].description;
            this.settings.promotionalContents[i].advertisementImageUrl = this.promotionImages[i];
          }
        }

        /**
 * search for the storage file URL if model implements FileMetadata
 */
        searchFile(filedetails, defaultUrl): string {
            let fileUrl = defaultUrl;
           
            if (filedetails
                && filedetails.meevoFile
                && filedetails.meevoFile.files
                && filedetails.meevoFile.files.length > 0) {

                filedetails.meevoFile.files.forEach(function (setting) {
                    if (setting.key === "Source") {
                        fileUrl = setting.fileUrl;
                    }
                });

            }
            return fileUrl;
        }


        static factory(): Function {
            let instance = (
                $q,
                appSettings: Meevo.Components.Common.IAppSettings,
                dataService: Meevo.Components.BaseClasses.IDataService
            ) => {
                return new WalkInSettingsService($q, appSettings, dataService);
            };

            instance.$inject = [
                '$q',
                'meevo.AppSettings',
                'meevo.components.common.DataService'
            ];
            return instance;
        }



    }
    angular.module("meevo.plugins.walkinManager")
        .service('meevo.plugins.walkinManager.WalkInSettingsService', WalkInSettingsService.factory());

}